<template>
  <div class="mx-10 ma-5">
    <v-card
      class="pa-5"
      :style="{ border: '1px solid var(--primary-boarder-color)' }"
    >
      <v-row class="ma-1 mx-7">
        <v-col
          cols="12"
          xs="6"
          sm="4"
          md="2"
          lg="2"
          xl="2"
          class="ma-0 pa-0 pt-2"
        >
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="grey-lighten-3"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"
            single-line
            hide-details
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="6" sm="4" md="2" lg="2" xl="2" class="ma-0 pa-0">
          <v-autocomplete
            v-model="filterProject"
            :items="projects"
            :item-text="formatProjectName"
            item-value="uuid"
            label="Filter by Project"
            clearable
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"
            dense
            :search-input.sync="projectSearch"
            @update:search-input="searchProjects"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" xs="6" sm="4" md="2" lg="2" xl="2" class="ma-0 pa-0">
          <v-autocomplete
            v-model="selectedStage"
            :items="stages"
            item-text="name"
            item-value="name"
            label="Filter by Stage"
            clearable
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" xs="6" sm="4" md="2" lg="2" xl="2" class="ma-0 pa-0">
          <v-autocomplete
            v-model="selectedCategory"
            :items="categories"
            item-text="name"
            item-value="name"
            label="Filter by Category"
            clearable
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" xs="6" sm="4" md="2" lg="2" xl="2" class="ma-0 pa-0">
          <v-autocomplete
            v-model="filterStatus"
            :items="statusOptions"
            item-text="label"
            item-value="label"
            label="Filter by Status"
            clearable
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" xs="6" sm="4" md="2" lg="2" xl="2" class="ma-0 pa-0 ">
          <v-btn
            depressed
            @click="clearFilters"
            dark
            color="#00B3FF"
            :loading="loading"
            class="ma-2"
            >clear Filters<v-icon dark>clear</v-icon></v-btn
          >
        </v-col>
      </v-row>
      <v-progress-linear
        indeterminate
        color="blue"
        v-if="loading"
      ></v-progress-linear>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="tasks"
        item-value="uuid"
        :hide-default-footer="true"
        :disable-sort="true"
        :disable-pagination="true"
        :hide-default-header="false"
        id="data-table"
      >
        <template v-slot:item="{ item, index }">
          <tr
            :class="index % 2 === 0 ? 'dark-row' : 'light-row'"
            class="custom-row"
          >
            <td>
              {{ item.task_code }}
            </td>
            <td>
              <router-link :to="'/task/info/' + item.uuid" class="router-link font-weight-medium">
                <div>
                  {{ item.task_title }}
                </div>
              </router-link>
            </td>
            <td>
              <v-chip
                small
                :color="
                  item.stage && item.stage.color_code
                    ? item.stage.color_code
                    : 'primary'
                "
                class="white--text"
              >
                {{ item.stage ? item.stage.name : "" }}
              </v-chip>
            </td>
            <td>
              <v-chip
                small
                :color="
                  item.category && item.category.color_code
                    ? item.category.color_code
                    : '#2979FF'
                "
                class="white--text"
              >
                {{ item.category ? item.category.name : "" }}
              </v-chip>
            </td>
            <td>
              <v-chip
                class="ma-2"
                small
                :color="getStatusColors(item.status).chip"
                :text-color="getStatusColors(item.status).text"
              >
                {{ stringFormatting(item.status) }}
              </v-chip>
            </td>
            <td>
              <div>
                {{ item.due_at }}
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-row class="my-1">
        <Pagination
          v-model="page"
          :loading="loading"
          :total="total"
          :page="page"
        ></Pagination>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { TaskService } from "@/services/task-service.js";
import { ProjectService } from "@/services/project-service.js";
import { checkError } from "@/config/errors.js";
import Pagination from "@/components/shared/Pagination";
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  name: "ProjectGrid",
  components: { Pagination },
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),
      loading: false,
      selectedStatus: "",
      filterStatus: "",
      filterProject: "",
      selectedStage: null,
      selectedCategory: null,
      selectedMember: null,
      search: "",
      projectSearch: "",
      page: 1,
      total: 0,
      totalTask: 0,
      categories: [],
      stages: [],
      statusOptions: [
        { id: 1, label: "IN-PROGRESS" },
        { id: 2, label: "COMPLETED" },
        { id: 3, label: "HOLD" },
        { id: 4, label: "PENDING" },
      ],
      headers: [
        { text: "Task Code", value: "task_code" },
        { text: "Title", value: "task_title" },
        { text: "Stage", value: "stage" },
        { text: "Category", value: "category" },
        { text: "Status", value: "status" },
        { text: "Due Date", value: "due_at" },
      ],
      tasks: [],
      errors: null,
      snackbar: false,
      succesMsg: "",
      projects: [],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getTasksList();
    this.getStagesAndCategories();
    this.getProjectList();
  },

  watch: {
    search() {
      this.page = 1;
      this.getTasksList();
    },
    page() {
      this.getTasksList();
    },
    filterStatus() {
      this.getTasksList();
    },
    filterProject() {
      this.getTasksList();
    },
    selectedStage() {
      this.getTasksList();
    },
    selectedCategory() {
      this.getTasksList();
    },
    selectedMember() {
      this.getTasksList();
    },
    "$route.query.status": {
      handler() {
        this.filterStatus = this.$route.query.status
      },
      immediate: true,
    },
  },

  methods: {
    getTasksList() {
      this.loading = true;
      TaskService.getMyTasks(
        this.search ?? "",
        this.filterProject,
        this.filterStatus,
        this.selectedStage,
        this.selectedCategory,
        this.selectedMember,
        this.page
      )
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.tasks = response.data.data || [];
            this.total = response.data.meta.last_page || 0;
            this.totalTask = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.tasks = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getStagesAndCategories() {
      this.loading = true;
      TaskService.getTaskStagesAndCategories()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.categories = response.data.categories || [];
            this.stages = response.data.stages || [];
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          this.errors = data;
        });
    },
    getProjectList() {
      this.loading = true;
      ProjectService.getUserProjectNameList(this.projectSearch ?? "")
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    formatProjectName(project) {
      if (project && project.project_name && project.project_code) {
        return `${project.project_code} - ${project.project_name}`;
      } else {
        return project.project_code;
      }
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    searchChange(value) {
      this.search = value;
    },

    closeSnackbar() {
      this.snackbar = false;
    },
    clearFilters() {
      this.selectedStage = null;
      this.selectedCategory = null;
      this.selectedMember = null;
      this.filterStatus = "";
      this.filterProject = "";
      this.search = "";
      this.getTasksList();
    },
    searchProjects(value) {
      if (value !== null && value.trim() !== "" && !this.loading) {
        if (this.projectSearchTimeout) {
          clearTimeout(this.projectSearchTimeout);
        }
        this.projectSearchTimeout = setTimeout(() => {
          this.projectSearch = value.trim();
          this.getProjectList();
        }, 2000);
      }
    },
  },
};
</script>
